import React, {useState, useEffect, useCallback} from 'react'
import { useParams } from 'react-router-dom';
import {Spinner} from '@material-tailwind/react'
import { debounce } from 'lodash';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import moment from 'moment';
import { TrashIcon } from '@heroicons/react/24/outline';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Input
} from "@material-tailwind/react";

import { useWallet, useWallets } from '@wallet-standard/react';
import { getPATokenMintTickersForBrc20 } from '../../util/new-api';
import CountdownCard from '../../components/CountdownCard';
import { getTxDataById } from '../../util/api';
import { useTranslation } from 'react-i18next';
import { SessionsStorageKeys } from '../../services/session-storage';
import { getTransactionData } from '../../util/dust20-api';
import { formatInscriptionId } from '../../util/format-data';
import FeeRateCard from '../../components/FeeRateCard';
import { launchpadTokenRandom } from '../../util/new-api';
import { dust20TransferFee, tippingAddress } from '../../configs/constant';
import { getDust20UnlockPsbt } from '../../util/dust20-api';

export default function UnlockUtxos() {
  const { param } = useParams();

  const { t, i18n } = useTranslation();
  const { wallets } = useWallets();

  const feeRates = useSelector(state => state.feeRate);
  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);

  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(feeRates.Normal);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);

  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState('');
  const [selectedUtxos, setSelectedUtxos] = useState([]);
  const [totalSats, setTotalSats] = useState(0);
  const [totalUtxos, setTotalUtxos] = useState(0);


  useEffect(() => {
    const updateFees = async () => {
      if (feeRateMode == "Custom") {
        setFeerate(customFee);
      }
      else
      {
        setFeerate(feeRates[feeRateMode]);
        if (customFee == 0) 
        {
          setCustomFee(feeRates["Fast"] + 1);
        }
      }
    }

    updateFees();

  }, [feeRateMode, customFee, feeRates])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  const handleRemove = (data) => {
    let tempData = [];
    for(let temp of selectedUtxos) {
      if (temp.txid != data.txid || temp.vout != data.vout) tempData.push(temp);
    }
    setSelectedUtxos(tempData)
    setTotalSats(totalSats - data.value);
    setTotalUtxos(totalUtxos - 1);
  }

  const handleAdd = async () => {
    setLoading(true);
    if (wallet.nostrOrdinalsAddress == '') {
      toast.error(t('Connect Wallet Error Message'));
      setLoading(false);
      return;
    }

    let res = output.split(":");
    if (res.length != 2 || res[0].length != 64) {
      toast.error(t('Insert Valid Output Error Message'));
      setLoading(false);
      return;
    }

    let txid = res[0];
    let vout = parseInt(res[1]);

    try{
      let txDataRaw = await getTransactionData(txid);
      let txData = JSON.parse(txDataRaw.data);
      
      let address = txData.vout[vout].scriptpubkey_address;
      let value = txData.vout[vout].value;

      if (address != wallet.nostrOrdinalsAddress) {
        toast.error(t('Insert Valid Output Error Message'));
        setLoading(false);
        return;  
      }

      setSelectedUtxos((prevData) => {
        return [...prevData, {txid, vout, value, output}];
      });

      setOutput('');
      setTotalSats(totalSats + value);
      setTotalUtxos(totalUtxos + 1);
    }
    catch(e) {
      toast.error(t('Insert Valid Output Error Message'));
      setLoading(false);
      return;
    }

    setLoading(false);
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const handleUnlock = async() => {
    setLoading(true);
    let results = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 1) // dustzero

    let padding = 546;
    let fundingAddress = tippingAddress;
    let fundingAmount = 0;
    if (results.data.length == 0) {
      fundingAmount = dust20TransferFee;
    }
    
    let totalFee = 0
    if (totalUtxos == 1) {
      totalFee = calculateFee(totalUtxos, 2, feerate);
    }
    else {
      totalFee = calculateFee(totalUtxos, 1, feerate) + calculateFee(1, 2, feerate);
    }
    
    if (fundingAmount == 0) {
      totalFee = totalFee + padding;
    }
    else totalFee = totalFee + fundingAmount;

    console.log("-----totalFee-------", totalFee);
    
    if (totalFee > totalSats / 2) {
      toast.error("Please add more utxos!");
      setLoading(false);
      return;
    }

    let isSuccess = true;
    let outputData = [];
    if (totalUtxos == 1) {
      let sats = 0;
      if (fundingAmount == 0) {
        sats = padding;
        outputData = [
          {
            address: wallet.nostrOrdinalsAddress,
            value: padding
          }
        ]
      }
      else {
        sats = fundingAmount;
        outputData = [
          {
            address: fundingAddress,
            value: sats
          }
        ]
      }
      outputData.push({
        address: wallet.nostrPaymentAddress,
        value: totalSats - sats - calculateFee(totalUtxos, 2, feerate)
      })
    }
    else {
      outputData = [{
        address: wallet.nostrOrdinalsAddress,
        value: totalSats - calculateFee(totalUtxos, 1, feerate)
      }]
    }

    let param = {
      utxos: selectedUtxos,
      outputData,
      pubkey: wallet.ordinalsPublicKey,
      provider: wallet.domain
    }

    let paymentUtxos = await getDust20UnlockPsbt(param);
    let txid;
    try{
      if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos);
        txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos);
        txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos);
        txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let signIndexes = [];
        for(let i=0;i< selectedUtxos.length; i++){
          signIndexes.push(i);
        }

        await signTransaction({
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => {
            txid = response;
          },
          onCancel: () => {
              toast.error(t('Request canceled'));
              setLoading(false);
              isSuccess = false
              return;
          },
        });
       }
      else if (wallet.domain == "magiceden") {
        let signIndexes = [];
        for(let i=0;i<selectedUtxos.length; i++){
          signIndexes.push(i);
        }

        let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

        await signTransaction({
          getProvider: async () =>
            magicedenWallets[0].features['sats-connect:'].provider,
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => {
            txid = response 
          },
          onCancel: () => {
              toast.error(t('Request canceled'));
              setLoading(false);
              isSuccess = false;
              setShow(false);
          },
        });
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      toast.error(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      return;
    }
    if (isSuccess) {
      if (totalUtxos > 1) {
        let selectedUtxos = [{
          txid: txid,
          vout: 0,
          value: outputData[0].value
        }];

        let sats = 0;
        if (fundingAmount == 0) {
          sats = padding;
          outputData = [
            {
              address: wallet.nostrOrdinalsAddress,
              value: padding
            }
          ]
        }
        else {
          sats = fundingAmount;
          outputData = [
            {
              address: fundingAddress,
              value: sats
            }
          ]
        }
        outputData.push({
          address: wallet.nostrPaymentAddress,
          value: selectedUtxos[0].value - sats - calculateFee(1, 2, feerate)
        })
      }

      try{
        let param = {
          utxos: selectedUtxos,
          outputData,
          pubkey: wallet.ordinalsPublicKey,
          provider: wallet.domain
        }
        let paymentUtxos = await getDust20UnlockPsbt(param);
        let txid;

        if (wallet.domain == "tapwallet") {
          const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos);
          txid = await window.tapwallet.pushPsbt(signedPsbt);
        }
        if (wallet.domain == "unisat") {
          const signedPsbt = await window.unisat.signPsbt(paymentUtxos);
          txid = await window.unisat.pushPsbt(signedPsbt);
        }
        if (wallet.domain == "okxwallet") {
          const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos);
          txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
        }
        if (wallet.domain == "xverseWallet") {
          let signIndexes = [];
          for(let i=0;i< selectedUtxos.length; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: paymentUtxos,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
              txid = response;
            },
            onCancel: () => {
                toast.error(t('Request canceled'));
                setLoading(false);
                isSuccess = false
                return;
            },
          });
        }
        if (wallet.domain == "magiceden") {
          let signIndexes = [];
          for(let i=0;i<selectedUtxos.length; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: paymentUtxos,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
              txid = response 
            },
            onCancel: () => {
                toast.error(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
        }
      }
      catch(e)
      {
        toast.error(t('User Reject Request Error Message'));
        isSuccess = false;
        setLoading(false);
        return;
      }
      toast.success(t('Success!'));
    }
    setLoading(false)
  }

  const calculateFee = (vins, vouts, feerate) => {
    let recommendedFeeRate = parseFloat(feerate);
    if (typeof recommendedFeeRate !== "number" || recommendedFeeRate <= 0)
      throw new Error("Invalid fee rate.");
  
    const baseTxSize = 10;
    const inSize = 57.5;
    const outSize = 43;
    const txSize = baseTxSize + vins * inSize + vouts * outSize;
    const fee = Math.round(txSize * recommendedFeeRate);
    return fee;
  }

  const handleCopy = (value, mode) => {
    navigator.clipboard.writeText(value).then(
      () => {
        // Successfully copied to clipboard
        if (mode == 1)
          toast.success(t('Name Copied!'));
        else
          toast.success(t('Address Copied!'));
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy address: ', err);
      }
    );
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
      }
      <div className="text-white font-semibold sm:text-[30px] text-[24px] mt-10 text-center bg-primary py-1 px-4 rounded-md">{t('UNLOCK')} {t('UTXO')}</div>
      <div className="md:min-w-[600px] min-w-[300px] border-gray-800 border-[1px] border-solid p-4 rounded-lg mt-5 flex flex-col gap-2 bg-[#081817] md:w-[600px] w-full">
        <div className="font-bold">Manually Input Utxos</div>
        <div>
          <Input type="text" color="white" label = {t('Output')} className="w-full md:min-w-[500px] min-w-[250px]" value={output} onChange = {(e) => {setOutput(e.target.value)}}/>
        </div>
        <div className="flex flex-row justify-end">
          <div className="px-8 py-2 bg-primary hover:bg-primary-hover rounded-md cursor-pointer" onClick={handleAdd}>{t('ADD')}</div>
        </div>
      </div>
      <div className="md:min-w-[600px] min-w-[300px] border-gray-800 border-[1px] border-solid p-4 rounded-lg mt-5 flex flex-col gap-2 bg-[#081817] md:w-[600px] w-full overflow-scroll max-h-[400px]">
        <div className="font-bold">Selected Utxos ({totalUtxos} Utxos , {totalSats} Sats)</div>
        {
          selectedUtxos.length > 0 ? 
          selectedUtxos.map((data) => {
            return  <div className="flex flex-row gap-2 justify-between items-center text-white" key={data.output}>
              <div>{formatInscriptionId(data.output)}, {data.value}</div>
              <TrashIcon strokeWidth={2} className="h-5 w-5 cursor-pointer text-primary" onClick={() => {handleRemove(data)}}/>
            </div>
            }) 
          : 
          <></>
        }
      </div>
      <div className="md:min-w-[600px] min-w-[300px] border-gray-800 border-[1px] border-solid p-4 rounded-lg mt-5 flex flex-col gap-2 bg-[#081817] md:w-[600px] w-full overflow-scroll max-h-[400px]">
        <div className="grid grid-cols-3 gap-3">
          <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
          <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
          <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
        </div>
        {
          feeRateMode == "Custom" ? 
          <div className="flex flex-row gap-3 items-center">
            <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
            <div className="sm:max-w-[200px] w-full">
              <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
            </div>
          </div>
          : 
          <></>
        }
        <div className="flex flex-row justify-center">
          <div className="px-8 py-2 bg-primary hover:bg-primary-hover rounded-md cursor-pointer mt-4" onClick={handleUnlock}>{t('UNLOCK')}</div>
        </div>
      </div>
    </div>
  )
}
